export default __webpack_public_path__ + "static/media/arrow-white-right.24e91e97.svg";